import React from 'react';
var WindowStateContext = React.createContext(null);
export var WindowStateProvider = WindowStateContext.Provider;
export var WindowStateConsumer = WindowStateContext.Consumer;
export default WindowStateContext;
//# sourceMappingURL=window-state-context.js.map